import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Home/_TAR6266-1.jpg";
import img2 from "../../assets/Images/Home/f06b850cf2f597b180e3a5f97f3fc3f5.jpg";
import img3 from "../../assets/Images/Logos/Logo_HD_White.png";
import img4 from "../../assets/Images/Logos/LogoSwell_White.png";
import { GoDotFill } from "react-icons/go";
import { useIsMobile } from "../../utils/responsive";

export default function Portfolio() {
  const isMobile = useIsMobile();
  const [hoveredItem, setHoveredItem] = useState(null);

  const Panel = ({
    image,
    number,
    logo,
    tagline,
    established,
    index,
    onClick,
  }) => (
    <div
      onMouseEnter={() => setHoveredItem(index)}
      onMouseLeave={() => setHoveredItem(null)}
      className="image-container"
      style={{
        height: isMobile ? "400px" : "690px",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {/* Image */}
      <img
        src={image}
        alt={`Project ${number}`}
        className="image-cover-full-responsive"
        style={{
          transform: hoveredItem === index ? "scale(1.05)" : "scale(1)",
          transition: "transform 0.5s ease",
        }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor:
            hoveredItem === index ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.5)",
          transition: "background-color 0.5s ease",
        }}
      />

      {/* Combined Overlay Content */}
      <div
        style={{
          position: "absolute",
          bottom: "5%",
          left: "5%",
          right: "5%",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          color: "white",
          fontFamily: "BodoniModa_18pt, serif",
        }}
      >
        {/* Number */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <h3 className="heading-sm">{number}.</h3>
        </div>
        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <img
            src={logo}
            alt={`Logo ${number}`}
            style={{
              width: "auto",
              height: "50px",
              opacity: hoveredItem === index ? 1 : 0.8,
              transition: "all 0.5s ease",
            }}
          />
        </div>
        {/* Tagline and Established */}
        <div
          className="border-bottom-white border-right-white border-top-white border-left-white"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "stretch",
            fontFamily: "BodoniModa-VariableFont_wght, serif",
          }}
        >
          <p
            className="border-right-white body-xs"
            style={{
              margin: 0,
              padding: !isMobile ? "12px" : "6px",
              width: isMobile ? "100%" : "75%",
              borderRight: isMobile ? "none" : "1px solid white",
              borderBottom: isMobile ? "1px solid white" : "none",
              display: "flex",
              alignItems: "center",
              justifyContent: isMobile ? "center" : "flex-start",
              flexWrap: "wrap",
              gap: "12px",
              fontSize: isMobile ? "10px" : "12px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {tagline.map((t, i) => (
              <React.Fragment key={i}>
                {t}
                {i < tagline.length - 1 && (
                  <>
                    <GoDotFill />
                  </>
                )}
              </React.Fragment>
            ))}
          </p>
          <p
            style={{
              margin: 0,
              padding: !isMobile ? "12px" : "2px",
              width: isMobile ? "100%" : "25%",
              textAlign: "center",
              fontSize: isMobile ? "10px" : "12px",
            }}
          >
            {established}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <Container fluid className="p-0">
      {/* Header */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{ width: "5%" }}
          />
        )}
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{ width: "45%" }}
          />
        )}
        <div
          className="border-bottom-black"
          style={{ width: isMobile ? "100%" : "45%" }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0">PORTFOLIO.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{ width: "5%" }}
          />
        )}
      </div>

      {/* Panels */}
      <div
        className="d-flex justify-content-center"
        style={{ flexDirection: isMobile ? "column" : "row" }}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{ width: "5%" }}
          />
        )}

        <div
          className={`border-bottom-black ${!isMobile && "border-right-black"}`}
          style={{ width: isMobile ? "100%" : "45%", padding: 0 }}
        >
          <Panel
            image={img1}
            number={1}
            logo={img3}
            tagline={[
              "Interior Design",
              "Interior Styling",
              "Bespoke Furniture",
            ]}
            established="Est. 2014"
            index={1}
            onClick={() => {
              window.open(
                "https://www.instagram.com/house.of.dec.emb.er?igsh=MXF5YWdrYjhuYWVubQ==",
                "_blank"
              );
            }}
          />
        </div>

        <div
          className="border-bottom-black"
          style={{ width: isMobile ? "100%" : "45%", padding: 0 }}
        >
          <Panel
            image={img2}
            number={2}
            logo={img4}
            tagline={["Home Decor Collective"]}
            established="Est. 2026"
            index={2}
            onClick={() => {
              window.open("https://www.instagram.com/dwell_byhod?igsh=MWpvcjN3cGZmazI2dA==", "_blank");
            }}
          />
        </div>

        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{ width: "5%" }}
          />
        )}
      </div>
    </Container>
  );
}
